// extracted by mini-css-extract-plugin
module.exports = {"wrap":"LoadingScreen_wrap__11K7v","logoWrap":"LoadingScreen_logoWrap__2VXIy","logo":"LoadingScreen_logo__1yT7u","indicator":"LoadingScreen_indicator__1Iuow"};